import { Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';

// import Permisos
import { permiso } from '../../components/shared/permisos';

@Injectable({
  providedIn: 'root'
})
export class TitleService {

  // Permisos
  public permisos: any = [];
  public permisosUnicos: any;
  public roles: any = [];
  public role: any;
  public tituloRol: string;

  // Lista de permisos registrados
  public permisosLista;

  constructor(private titleService: Title) {
    this.permisosLista = permiso;
  }

  // Se define título según rol de usurio
  getTitulo() {
    // Consulta el usuario actual en el localStorage
    let localUser = JSON.parse(localStorage.getItem('currentUser'));

    // Valida que exista un usuario en el localStorage
    if (localUser === null) {
      return;
    }

    // Inicializa los array agrupados de permisos y roles
    this.permisos = [];
    this.roles = [];

    // Se listan los roles y se combinan los permisos en un solo array
    for (let i = 0; i < localUser.role.length; i++) {
      this.permisos = this.permisos.concat(localUser.role[i].perm);
      this.roles = this.roles.concat(localUser.role[i].role[0]);
    }

    // Se elimina los elementos repetidos    
    this.permisosUnicos = this.permisos.filter((valor, indiceActual, arreglo) => arreglo.indexOf(valor) === indiceActual);
    this.role = this.roles.filter((valor, indiceActual, arreglo) => arreglo.indexOf(valor) === indiceActual);

    // Se guardan los permisos en el localStorage
    localStorage.setItem('permisosUnicos', JSON.stringify(this.permisosUnicos));

    // Asigna el título según los permiso
    if (this.role.indexOf(this.permisosLista.dvlpRole) > -1 && this.permisosUnicos.indexOf(this.permisosLista.gDvlp) > -1) {
      this.tituloRol = 'Developer';
    }
    else if (this.role.indexOf(this.permisosLista.stdagAdmRole) > -1 && this.permisosUnicos.indexOf(this.permisosLista.gSifac) > -1 && this.permisosUnicos.indexOf(this.permisosLista.gFnnz) > -1) {
      this.tituloRol = 'Stdag Admin';
    }
    else if (this.role.indexOf(this.permisosLista.sfacAdmRole) > -1 && this.permisosUnicos.indexOf(this.permisosLista.gSifac) > -1 && this.permisosUnicos.indexOf(this.permisosLista.gFnnz) > -1) {
      this.tituloRol = 'Sifac Admin';
    }
    else if (this.role.indexOf(this.permisosLista.auditorRole) > -1) {
      this.tituloRol = 'Auditoria';
    }
    else if (this.permisosUnicos.indexOf(this.permisosLista.gSifac) > -1) {
      this.tituloRol = 'SIFAC';
    }
    else if (this.permisosUnicos.indexOf(this.permisosLista.gFnnz) > -1) {
      this.tituloRol = 'Finanzas';
    }
    else if (this.permisosUnicos.indexOf(this.permisosLista.gBoleto) > -1) {
      this.tituloRol = 'Vuelos';
    }
    else if (this.permisosUnicos.indexOf(this.permisosLista.gAutos) > -1) {
      this.tituloRol = 'Vehículos';
    }
    else if (this.permisosUnicos.indexOf(this.permisosLista.gContra) > -1) {
      this.tituloRol = 'Contraparte Tec.';
    }
    else {
      this.tituloRol = 'STDAG'
    }

    return {
      titulo: this.tituloRol,
      permisos: this.permisosUnicos,
      user: localUser
    }
  }

  // Asigna título a la página/tab
  public setTitle(newTitle: string) {
    if (JSON.parse(localStorage.getItem('currentUser')) === null) {
      this.tituloRol = 'STDAG'
    }

    if (this.tituloRol === undefined) {
      this.tituloRol = 'STDAG';
      this.titleService.setTitle(this.tituloRol + ' - ' + newTitle);
    } else {
      this.titleService.setTitle(this.tituloRol + ' - ' + newTitle);
    }
  }
}
